import styled from 'styled-components';

export const StyledTopBarContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 20px;
`
export const StyledTopBarWrapper = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 650px) {
        flex-direction: column;
    }   
`

export const StyledSelect = styled.select`
    background-color: rgba(0, 0, 0, 0);
    border: none;
    outline: none;
    color: white;
    margin-left: 0.5rem;
    text-align: right;
    font-size: 14px;

    @media (max-width: 650px) {
        font-size: 12px;
    }
`

export const StyledOption = styled.option`
    background-color: #416043;
    border: none;
    outline: none;
    color: white;
    font-size: 14px;

    @media (max-width: 650px) {
        font-size: 12px;
    }
`

export const StyledStyleImage = styled.img`
    cursor: pointer;
`

export const StyledStyledTitle = styled.h1`
    color: white;
    margin-right: 36px;
    font-size: 36px;

    @media (max-width: 650px) {
        font-size: 24px;
    }
`

export const StyledStyledSortTitle = styled.span`
    color: white;
    font-size: 14px;

    @media (max-width: 650px) {
        font-size: 12px;
    }
`